import { useSearchParams, useNavigate } from "react-router-dom";
import BreadcrumbDatos from "./BreadcrumbDatos";
import { Form, Row, Col, Button, Alert, Card, Accordion, Image } from "react-bootstrap";
import { useEffect, useState } from "react";
import { getMarcas } from "../../services/MarcasService";
import { importarProductos } from "../../services/ProductosService";
import { useForm } from "react-hook-form";

export default function ProductosImportar() {

    let [searchParams, setSearchParams] = useSearchParams();
    
    const navigate = useNavigate();

    const [marcas, setMarcas] = useState([]);
    const [error, setError] = useState("");
    const [resultado, setResultado] = useState({
        estado: "iniciado"
    });

    const marca = searchParams.get('marca');
    const init = {
        "marca_id": marca,
        "inactivar_restantes": false,
        "file": null
    }

    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        defaultValues: {...init}
    });

    useEffect(() => {
        getMarcas()
            .then((resp) => {
                if (resp.error) {
                    setError(resp.message);
                } else {
                    setMarcas(resp.data);
                }
            });
    }, []);

    function beforeSubmit() {
        setResultado({
            estado: "pendiente"
        });
    }

    const onSubmit = async (data) => {
        let resp = await importarProductos(data);
        if (resp.error) {
            setError(resp.messages);
            setResultado({
                estado: "iniciado"
            });
        } else {
            setError("");
            setResultado({
                estado: "finalizado",
                ...resp.data
            });
        }
    }

    function volver() {
        let params = "";
        if (marca!=='')
            params = '?marca='+marca;
        navigate("/productos"+params);
    }
    
    return <>
        <BreadcrumbDatos active="Productos - Importar"></BreadcrumbDatos>
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Marca
                </Form.Label>
                <Col sm="6">
                    <Form.Select 
                        id="marca_id"
                        value={marca} disabled={true}
                        {...register("marca_id", {required:true})} >
                        <option value="">Seleccione marca...</option>
                        {marcas.map((m) => <option key={m.marca_id} value={m.marca_id}>{m.nombre}</option>)}
                    </Form.Select>
                </Col>
                {errors.marca_id?.type === 'required' && <Col className="validacion error"><p role="alert">Marca es requerida.</p></Col>}
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Archivo (.csv)
                </Form.Label>
                <Col sm="6">
                    <Form.Control type="file" multiple={false} {...register("file", {required:true})}  />
                </Col>
                {errors.file?.type === 'required' && <Col className="validacion error"><p role="alert">Archivo es requerido.</p></Col>}
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                </Form.Label>
                <Col xs="auto">
                    <Form.Check
                        type="checkbox"
                        {...register("inactivar_restantes")}
                        id="inactivar_restantes"
                        className="mb-2"
                        label="Inactivar restantes"
                    />
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                </Form.Label>
                <Col xs="auto">
                    <Button onClick={beforeSubmit} type="submit">Importar</Button>
                    <Button variant="secondary" onClick={volver}>{resultado.estado=="iniciado"?'Cancelar':'Volver'}</Button>
                </Col>
            </Form.Group>
        </Form>
        {error!==''?
            <Row>
                <Form.Label column sm="2">
                </Form.Label>
                <Col xs="auto">
                    <Alert variant="danger" key="danger">{error}</Alert>
                </Col>
            </Row>:
            <></>
        }
        {resultado.estado=="finalizado"?
            <Card bg={'secondary'} text={'white'}>
                <Card.Body>
                    <Card.Title>Resultado importación</Card.Title>
                    <div>
                        <Row>
                            <Form.Label column sm="2">
                            </Form.Label>
                            <Col xs="auto" className="mt-2">
                                <span>Filas procesadas: <strong>{resultado?.filas_procesadas}</strong></span>
                            </Col>
                        </Row>
                        <Row>
                            <Form.Label column sm="2">
                            </Form.Label>
                            <Col xs="auto" className="mt-2">
                                <span>Filas importados: <strong>{resultado?.filas_ok}</strong></span>
                            </Col>
                        </Row>
                        <Row>
                            <Form.Label column sm="2">
                            </Form.Label>
                            <Col xs="auto" className="mt-2">
                                <span>Filas con errores: <strong>{resultado?.filas_error}</strong></span>
                            </Col>
                        </Row>
                        <Row>
                            <Form.Label column sm="2">
                            </Form.Label>
                            <Col sm="8" className="mt-2">
                            <Accordion flush>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Mensajes de error</Accordion.Header>
                                    <Accordion.Body>
                                        {resultado?.errores.map((e,i) => <p key={i} style={{marginBottom: 0.2+'em'}}>{e}</p>)}
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                            </Col>
                        </Row>
                    </div>
                </Card.Body>
            </Card>
            :(resultado.estado=="pendiente"?
                <Row>
                    <Col xs="auto" style={{flex: 'auto'}}>
                        <Image src={process.env.PUBLIC_URL+'/cargando.gif'} style={{flex: 'auto', width: 100 +'px'}} />
                    </Col>
                </Row>
                :<></>)
        }
    </>
}